import { Product, SavedProduct } from "@/types";
import React from "react";
import { getProductsByIDArray } from "../ApiCalls/Base/GetProducts";

export function getUniqueDeviceId(): string {
    // let deviceId = "";
    // if (
    //     "navigator" in window &&
    //     "deviceMemory" in navigator &&
    //     "hardwareConcurrency" in navigator
    // ) {
    //     deviceId += navigator.deviceMemory || "";
    //     deviceId += navigator.hardwareConcurrency || "";
    // }

    return "0";
}

export async function signout(setSignedIn: React.Dispatch<React.SetStateAction<boolean>>, showSnackbar: (time: number, status: number, message: string) => void) {
    const response = await fetch("/api/user/auth/logout", {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    })
    const data = await response.json();
    if ((data.message as string).toLowerCase() === "success") {
        setSignedIn(false);
        localStorage.clear();
        showSnackbar(3000, 0, "Signed out successfully");
    }
    else {
        console.log(data.message);
        showSnackbar(3000, 1, "Error signing out!");
    }
}

export async function processApiResponse(response: any) {
    let responseText;
    try {
        responseText = await response.text();
        const responseJson = JSON.parse(responseText);
        return responseJson;
    } catch (error) {
        const result = { responseText: responseText };
        return result;
    }
}

export async function getCookies() {
    const response = await fetch("/api/getCookies");
    const data = await response.json();
    return data;
}

export const domain = "http://localhost:3000";


export function cleanUrl(url: string) {
    return JSON.parse(url);
}

export function toLocalDate(date: string, time = true) {
    if (!time)
        return new Date(date).toLocaleDateString(
            "en-US",
            {
                year: "numeric",
                month: "short",
                day: "numeric"
            }
        );
    else
        return new Date(date).toLocaleString(
            "en-US",
            {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true
            }
        );
}

export function getUniqueKey(packids: number[]) {
    if (packids.length > 1) {
        return packids.join("-");
    }
    else {
        return packids[0];
    }
}

export function createUniquePayPalProdId(packids: number[] | string[]) {
    packids = packids.map(id => parseInt(id.toString()));
    packids = packids.sort((a, b) => a - b);
    return `CHAIVIO-${packids.join('-')}`
}

export function getIdsFromKey(key: string) {
    return key.split("-").slice(1).map(id => parseInt(id));
}

export async function getAllProductsFromCart(cart: SavedProduct[] | Product[]) {
    const idSet = new Set(cart.map((item: any) => item.packids).flat())
    const products = await getProductsByIDArray(Array.from(idSet) as number[]);
    return products;
}